import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { logoutUser } from '../../../redux/actions/authActions'
import { withStyles } from '@material-ui/styles'
import { Theme } from '../../../utils/Theme'
import Header from '../../layout/Partials/Header'
import CardTitle from '../../../components/UI/CardTitle'
import * as Icon from 'react-feather'
import { Link } from 'react-router-dom'
import AccessDenied from '../../common/AccessDenied'
import AdminLayout from '../../layout/AdminLayout'

const styles = Theme()

class DynamicApplicationGeneration extends Component {
  render() {
    const { classes, auth } = this.props
    return (
      <AdminLayout>
        <div className="o-page">
          <Header>
            <h2 className="c-navbar__title">Dynamic Apps</h2>
          </Header>
          {auth.isAuthenticated && auth.user.role === 'Admin' ? (
            <div className="container">
              <div className={'row'}>
                <div className="col-md-4 col-xl-4 u-pr-zero u-pt-zero ">
                  <div className="c-card u-page-thumbnail">
                    <CardTitle
                      iconName={'Link'}
                      title={'Master Applications'}
                      className={'u-ml-small u-mr-small u-mt-xsmall u-mb-small'}
                    />

                    <p className={'u-mb-medium u-ml-small u-mr-small'}>
                      Create update delete dynamic application generation Qlik Sense Master Apps.
                    </p>
                    <Link
                      to="/settings/dag/master-apps"
                      className={`c-btn u-position-bl ${classes.buttonPrimary} has-arrow`}
                    >
                      Manage Master Applications
                    </Link>
                  </div>
                </div>

                <div className="col-md-4 col-xl-4 u-pr-zero u-pt-zero ">
                  <div className="c-card u-page-thumbnail">
                    <CardTitle className={'u-ml-small u-mr-small u-mt-xsmall u-mb-small'}>
                      <div className={'row'}>
                        <div className={'col-sm-2'}>
                          <div className="c-icon c-icon--large">
                            <Icon.Filter className={classes.colorPrimary} />
                          </div>
                        </div>
                        <div className={'col-sm-10'}>
                          <h5 className="u-mb-xsmall u-mt-xsmall">Filters</h5>
                        </div>
                      </div>
                    </CardTitle>

                    <p className={'u-mb-medium u-ml-small u-mr-small'}>
                      Create update delete dynamic application generation filters and manage filter values.
                    </p>
                    <Link
                      to="/settings/dag/filters"
                      className={`c-btn u-position-bl ${classes.buttonPrimary} has-arrow`}
                    >
                      Manage D.A.G Filters
                    </Link>
                  </div>
                </div>

                <div className="col-md-4 col-xl-4 u-pr-zero u-pt-zero ">
                  <div className="c-card u-page-thumbnail">
                    <CardTitle className={'u-ml-small u-mr-small u-mt-xsmall u-mb-small'}>
                      <div className={'row'}>
                        <div className={'col-sm-2'}>
                          <div className="c-icon c-icon--large">
                            <Icon.RefreshCcw className={classes.colorPrimary} />
                          </div>
                        </div>
                        <div className={'col-sm-10'}>
                          <h5 className="u-mb-xsmall u-mt-xsmall">Dynamic Applications</h5>
                        </div>
                      </div>
                    </CardTitle>

                    <p className={'u-mb-medium u-ml-small u-mr-small'}>
                      View dynamically generated applications, synchronise master applications users, filter values and
                      generate new dynamic applications.
                    </p>
                    <Link
                      to="/settings/dag/dynamic-apps"
                      className={`c-btn u-position-bl ${classes.buttonPrimary} has-arrow`}
                    >
                      Manage Dynamic Applications
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <AccessDenied classes={classes} history={this.props.history} />
          )}
        </div>
      </AdminLayout>
    )
  }
}

DynamicApplicationGeneration.propTypes = {
  logoutUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  classes: PropTypes.object,
  history: PropTypes.object,
}

const mapStateToProps = state => ({
  auth: state.auth,
})

export default connect(mapStateToProps, { logoutUser })(withStyles(styles)(DynamicApplicationGeneration))
